import { useEnsureAuthenticated } from "@/contexts/ensureAuthenticated";
import { Flex, Heading, Text, VStack } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { getParameters } from "@/services/pullInfoHome.service";

export default function Home() {
  const { user } = useEnsureAuthenticated();
  const [homeText, setHomeText] = useState<string>("");

  useEffect(() => {
    const fetchParameters = async () => {
      try {
        const response = await getParameters();
        setHomeText(response[0].value);
      } catch (error) {
        console.error("Error fetching parameters:", error);
      }
    };

    fetchParameters();
  }, []);

  return (
    <Flex w='100%' minH='100%' alignItems='center' justifyContent='center' bg='white'>
      <VStack spacing={4} zIndex={1} textAlign="center">
        <Heading as="h1" size="lg" fontFamily="Lexend Deca">
          {user?.name}, Seja bem-vindo(a) ao GranaTech!
        </Heading>
        <Text fontSize="lg" fontFamily="Lexend Deca">
          {homeText || "Navegue pelos nossos itens no menu"}
        </Text>
      </VStack>
    </Flex>
  );
}
